module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAaCAYAAADSbo4CAAAACXBIWXMAAAsSAAALEgHS3X78AAAA70lEQVRIie2XPQoCMRBGv9n1B0HCNqKljZXuAdbKe4hgZeEJvIj3cUFPYWHtAURck4xkkWU3gpUkFnnlNPMyzIQZYmbUOWXpkkArDR7BIa16qmOWbhVhLxQgZOzSoykCYCMUYVi4lTBEdkDIj5AfEV8EEZtKJJ+nYwb6j4ihyb0IHbJZEjOOijDtalIMxEXEGBYRhHJXMDO+ayPxTlzO7bWjcO1oiLs7EZMpSWTz9d7+kX/o2DC+NkHEJojYBBEbe0NrcO5J/yKT+1fHn/NfPXLztIPUMfvIGMClqwmDp78ClQdWPk8Xbaad66OqAsALOI0+iEB6IhsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat/seatSoldL.png
// module id = CbzJ
// module chunks = 1